import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

import { TestingTrailService, CommonService, OctTypeService } from '../../../services/index';
import { TestingTrailModel } from '../../../model/index';

@Component({
    selector: 'add-trail-window',
    templateUrl: './addTrail.component.html'
})
export class AddTrailComponent implements OnInit {
    title: string;
    public pageType: string;
    public list: any[] = [];
    haList: any[] = [];
    trailCtrl: FormControl;
    potCtrl: FormControl;
    potCusOptList: any[];
    trailList: any[];
    routeCtrl: FormControl;
    routeOptList: any[];
    modelCtrl: FormControl;
    programModelCtrl: FormControl;
    emplistCtrl: FormControl;
    emp2listCtrl: FormControl;
    macCtrl: FormControl;
    bilateralWillingCtrl: FormControl;
    bilateralWillingList: any[];
    filteredEmp: Observable<any[]>;
    filteredEmp2: Observable<any[]>;
    filteredBrandModel: Observable<any[]>;
    filteredBrand: Observable<any[]>;
    filteredFamily: Observable<any[]>;
    filteredSeries: Observable<any[]>;
    filteredPower: Observable<any[]>;
    filteredPerformance: Observable<any[]>;
    filteredBattery: Observable<any[]>;
    brandModelList$: any[] = [];
    brandModelCtrl: FormControl;
    brandList$: any[] = [];
    brandCtrl: FormControl;
    familyList$: any[] = [];
    seriesList$: any[] = [];
    powerList$: any[] = [];
    performanceList$: any[] = [];
    batteryList$: any[] = [];
    familyCtrl: FormControl;
    seriesCtrl: FormControl;
    powerCtrl: FormControl;
    performanceCtrl: FormControl;
    batteryCtrl: FormControl;
    filteredModel: Observable<any[]>;
    ModelList = [];
    haModelDet = [];
    haModelDelList = [];
    //trialList = [];
    programmingModel = [];
    machineTypeList = ['Single', 'Bilateral'];
    //public referencedata: any[] = [];
    //@Input() traildata: TestingTrailModel[] = [];
    _traildata: any[] = [];
    @Input() set traildata(data: any[]) {
        this._traildata = data;
        this.octFromWalkin = !!(data && (data['oct_type_id'] || data['oct_yn'] === 'Yes'));
        this.loadClientDetails(data['client_id']);
        if (data['is_edit'] === 'Yes') {
            this.loadExistingTrialModels();
        }
    }

    get traildata(): any[] {
        return this._traildata;
    }
    @Output() testingTrailLoadEvent = new EventEmitter();
    @ViewChild('singleClientDetails') singleClientDetails;
    // trigger-variable for Ladda
    isLoading: boolean = false;
    curBranch: any;
    octTypeList: any[] = [];
    octInitiatedByCtrl: FormControl;
    octInitiatedByList: any[] = [];
    octFromWalkin: boolean = false;
    filteredOctInitiatedBy: Observable<any[]>;

    constructor(public store: Store<fromRootStore.State>, private testingTrailService: TestingTrailService,
        public snackBar: MdSnackBar, public bsModalRef: BsModalRef,
        public toasterService: ToasterService, private commonService: CommonService, private octTypeService: OctTypeService) {
        this.octInitiatedByCtrl = new FormControl('');
        this.filteredOctInitiatedBy = this.octInitiatedByCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterOctInitiatedBy(name) : this.octInitiatedByList.slice());
        // Get current branch
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.curBranch = auth['branch_id'];
            }
        });
       //FOR AUTO COMPLETE VALIDATION ---
        function hasValidTrail(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No" ) {
                retVal = { inValidTrail: true };
            }
          
            return retVal;
        }
        this.trailCtrl = new FormControl('', [
            Validators.required,
            hasValidTrail.bind(this)
        ]);

         function hasValidPot(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No" ) {
                retVal = { inValidPot: true };
            }
          
            return retVal;
        }
        this.potCtrl = new FormControl('', [
            Validators.required,
            hasValidPot.bind(this)
        ]);
        //FOR AUTO COMPLETE VALIDATION ---
        function hasValidRoute(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No" ) {
                retVal = { inValidRoute: true };
            }
          
            return retVal;
        }
        this.routeCtrl = new FormControl('', [
            Validators.required,
            hasValidRoute.bind(this)
        ]);

        function hasValidProgramModel(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Trial" && ledgerID != "Programming") {
                retVal = { inValidRoute: true };
            }

            return retVal;
        }
        this.programModelCtrl = new FormControl('', [
            Validators.required,
            hasValidProgramModel.bind(this)
        ]);
       
       
        this.trailList = ['Yes', 'No'];
        this.potCusOptList = ['Yes', 'No'];
        this.routeOptList = ['Yes', 'No'];
        this.programmingModel = ['Trial', 'Programming'];

        //FOR AUTO COMPLETE VALIDATION --- BILATERAL WILLING CLIENT
        function hasValidBilateralWilling(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidBilateralWilling: true };
            }
            return retVal;
        }
        // Bilateral Willing Client is not required for branch_id 216
        if (this.curBranch == 216) {
            this.bilateralWillingCtrl = new FormControl('');
        } else {
            this.bilateralWillingCtrl = new FormControl('', [
                Validators.required,
                hasValidBilateralWilling.bind(this)
            ]);
        }
        this.bilateralWillingList = ['Yes', 'No'];

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        this.modelCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.filteredModel = this.modelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterModel(name) : this.ModelList.slice());

        function hasEmp(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEMP: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP: true };
            }
            return retVal;
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasEmp.bind(this)
        ]);
      //  this.halistCtrl = new FormControl();
        this.filteredEmp = this.emplistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        this.emp2listCtrl = new FormControl('', [
            Validators.required,
            hasEmp.bind(this)
        ]);
      //  this.halistCtrl = new FormControl();
        this.filteredEmp2 = this.emp2listCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidBrandModel(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBrandModel: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBrandModel: true };
            }
            return retVal;
        }
        this.brandModelCtrl = new FormControl('', [
            Validators.required,
            hasValidBrandModel.bind(this)
        ]);
        this.filteredBrandModel = this.brandModelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrandModel(name) : this.brandModelList$.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND COMBO
        function hasValidBrand(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidBrand: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidBrand: true };
            }
            return retVal;
        }
        this.brandCtrl = new FormControl('', [
            Validators.required,
            hasValidBrand.bind(this)
        ]);
        this.filteredBrand = this.brandCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrand(name) : this.brandList$.slice());

        //FOR AUTO COMPLETE VALIDATION --- FAMILY COMBO
        function hasValidFamily(input: FormControl) {
            let familyID = input.value, retVal = null;
            if (familyID == "") {
                retVal = { inValidFamily: true };
            }
            if (familyID && typeof familyID === 'string') {
                retVal = { inValidFamily: true };
            }
            return retVal;
        }
        this.familyCtrl = new FormControl('', [
            Validators.required,
            hasValidFamily.bind(this)
        ]);
        this.filteredFamily = this.familyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterFamily(name) : this.familyList$.slice());
        
        //Series
        function hasValidSeries(input: FormControl) {
            let seriesID = input.value, retVal = null;
            if (seriesID && typeof seriesID === 'string') {
                retVal = { inValidSeries: true };
            }
            return retVal;
        }
        this.seriesCtrl = new FormControl('', hasValidSeries.bind(this));

        this.filteredSeries = this.seriesCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSeries(name) : this.seriesList$.slice());

        //Performance
        function hasValidPerformance(input: FormControl) {
            let performanceID = input.value, retVal = null;
            if (performanceID && typeof performanceID === 'string') {
                retVal = { inValidPerformance: true };
            }
            return retVal;
        }
        this.performanceCtrl = new FormControl('', hasValidPerformance.bind(this));

        this.filteredPerformance = this.performanceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPerformance(name) : this.performanceList$.slice());

        //Power
        function hasValidPower(input: FormControl) {
            let powerID = input.value, retVal = null;
            if (powerID && typeof powerID === 'string') {
                retVal = { inValidPower: true };
            }
            return retVal;
        }
        this.powerCtrl = new FormControl('', hasValidPower.bind(this));
        this.filteredPower = this.powerCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPower(name) : this.powerList$.slice());

        //Battery
        function hasValidBattery(input: FormControl) {
            let batteryID = input.value, retVal = null;
            if (batteryID && typeof batteryID === 'string') {
                retVal = { inValidBattery: true };
            }
            return retVal;
        }
        this.batteryCtrl = new FormControl('', hasValidBattery.bind(this));
        this.filteredBattery = this.batteryCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBattery(name) : this.batteryList$.slice());

    }

    ngOnInit(): void {
        this.loadStockModelList();
        this.loadChallanHaList();
        this.loadOctTypeList();
        //this.typeList = ['Doctor', 'Others'];
        this.store.select(fromCommonStore.getAllBrandModel).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList$ = res;
                return;
            }
            this.brandModelList$ = res;
        });
        this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandList$ = res;
                return;
            }
            this.brandList$ = res;
        });

        setTimeout(()=>{
            $('#trail').focus();
        },1000);
    }

    loadFamilyList() {
        let that = this;
        this.commonService
            .getFamilyList()
            .then(function(res: any) {
                // that.familyList$ = res.data;
                const familydata = res.data.filter(item => item.brand_id === that.haModelDet['brand_id']);
                that.familyList$ = familydata;
                that.familyCtrl.setValue(that.haModelDet['family_id']);
            });
    }

    loadClientDetails(clientID) {
        this.singleClientDetails.loadClient(clientID);//TO LOAD CLIENT OBJECT
    }
    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    loadExistingTrialModels() {
        let that = this;
        this.testingTrailService
            .getTrialDetailsByWalkinId({ walkin_id: this.traildata['walkin_id'] })
            .then(function(res: any) {
                if (res && res.success && res.data && res.data.length > 0) {
                    that.haModelDelList = res.data.map((item: any) => ({
                        model_id: item.ha_model_id,
                        hamodel_name: item.hamodel_name,
                        mrp: item.mrp,
                        brand_id: item.brand_id,
                        brand_name: item.brand_name,
                        brand_model_id: item.brand_model_id,
                        brand_model_name: item.brand_model_name,
                        family_id: item.family_id,
                        family_name: item.family_name,
                        series_id: item.series_id,
                        series_name: item.series_name,
                        performance_id: item.performance_id,
                        performance_name: item.performance_name,
                        power_id: item.power_id,
                        power_name: item.power_name,
                        battery_id: item.battery_id,
                        battery_name: item.battery_name,
                        color_id: item.color_id,
                        color_name: item.color_name,
                        tele_audiology: item.tele_audiology,
                        programming_model: item.programming_model
                    }));
                }
            });
    }

    loadStockModelList() {
        let that = this,
            data = {
                type: 'HA Model',
                comp_stock: 'No'
            };
        this.commonService
            .getStockModelList(data)
            .then(function(res: any) {
                if (res.success) {
                    //that.actModelList = res.data;
                    that.ModelList = res.data;
                    that.modelCtrl.setValue(that.haModelDet['model_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    filterModel(name: string) {
        name = _.escapeRegExp(name);
        return this.ModelList.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayModelFn(modelID: number) {
        if (modelID && this.ModelList.length > 0) {
            let fitem = _.find(this.ModelList, { 'model_id': modelID });
            this.haModelDet['hamodel_name'] = fitem['name'];
            // this.haModelDet['programming_model'] = fitem['programming_model']
            this.haModelDet['brand_name'] = fitem['brand_name'];
            this.haModelDet['brand_model_name'] = fitem['brand_model_name'];
            this.haModelDet['family_name'] = fitem['family_name'];
            this.haModelDet['series_name'] = fitem['series_name'];
            this.haModelDet['performance_name'] = fitem['performance_name'];
            this.haModelDet['power_name'] = fitem['power_name'];
            this.haModelDet['battery_name'] = fitem['battery_name'];
            this.haModelDet['color_name'] = fitem['color_name'];
            this.haModelDet['color_id'] = fitem['color_id'];
            this.haModelDet['tele_audiology'] = fitem['tele_audiology'];
            this.haModelDet['mrp'] = fitem['mrp'];
            this.haModelDet['brand_id'] = fitem['brand_id'];
            this.haModelDet['brand_model_id'] = fitem['brand_model_id'];
            this.haModelDet['family_id'] = fitem['family_id'];
            this.haModelDet['series_id'] = fitem['series_id'];
            this.haModelDet['performance_id'] = fitem['performance_id'];
            this.haModelDet['power_id'] = fitem['power_id'];
            this.haModelDet['battery_id'] = fitem['battery_id'];
            return fitem['name'];
        }
        return '';
    }
    loadChallanHaList() {
        let that = this,
            data = {
                name: '',
                type:'challan'
            };
        this.commonService
            .getEmployeeName(data)
            .then(function(res: any) {
                that.haList = res['data'];
                that.octInitiatedByList = res['data'];
                that.emplistCtrl.setValue(that.traildata['trail_attender_name'] || '');
                that.emp2listCtrl.setValue(that.traildata['trail_attender_another_name'] || '');
                that.octInitiatedByCtrl.setValue(that.traildata['oct_initiated_by'] || '');
                if (that.octFromWalkin) {
                    that.octInitiatedByCtrl.disable();
                }
                if (that.traildata['is_edit'] === 'Yes') {
                    that.trailCtrl.setValue(that.traildata['trail'] || '');
                    that.potCtrl.setValue(that.traildata['potential_customer'] || '');
                    that.bilateralWillingCtrl.setValue(that.traildata['bilateral_willing_client'] || '');
                    that.routeCtrl.setValue(that.traildata['route_testing'] || '');
                }
            });
    }

    filterHa(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.haList.filter(ha => (new RegExp(empname, 'gi').test(ha.empid) 
            || new RegExp(empname, 'gi').test(ha.empname)));
    }

    displayHa(item_id: number) {

        if (item_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'empid': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
          //  this.getModelSerialNo(item_id);
            return fhalist['empname'];
        }
        return '';
    }

    //BRAND MODEL
    filterBrandModel(name: string) {
        name = _.escapeRegExp(name);
        return this.brandModelList$.filter(item => (new RegExp(name, 'gi').test(item.disp_name)));
    }
    displayFn(modelID: number) {
        if (modelID && this.brandModelList$.length > 0) {
            let fitem = _.find(this.brandModelList$, { 'model_id': modelID });
            this.haModelDet['disp_name'] = fitem['disp_name'];
            return fitem['disp_name'];
        }
        return '';
    }
    //BRAND
    filterBrand(name: string) {
        name = _.escapeRegExp(name);
        return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayBrandFn(brandID: number) {
        if (brandID && this.brandList$.length > 0) {
            let fitem = _.find(this.brandList$, { 'brand_id': brandID });
            this.haModelDet['brand_name'] = fitem['name'];
            return fitem['name'];
        }
        return '';
    }
    //FAMILY
    filterFamily(name: string) {
        name = _.escapeRegExp(name);
        return this.familyList$.filter(item => (new RegExp(name, 'gi').test(item.family_name)));
    }
    displayFamilyFn(familyID: number) {
        if (familyID && this.familyList$.length > 0) {
            let fitem = _.find(this.familyList$, { 'family_id': familyID });
            this.haModelDet['family_name'] = fitem['family_name'];
            return fitem['family_name'];
        }
        return '';
    }

    onChangeFamily(){
        this.loadFamilyList();
        this.loadAllList();
    }

    //Series
    filterSeries(name: string) {
        name = _.escapeRegExp(name);
        return this.seriesList$.filter(item => (new RegExp(name, 'gi').test(item.series_name)));
    }
    displaySeriesFn(seriesID: number) {
        if (seriesID && this.seriesList$.length > 0) {
            let seriesitem = _.find(this.seriesList$, { 'series_id': seriesID });
            this.haModelDet['series_name'] = seriesitem['series_name'];
            return seriesitem['series_name'];
        }
        return '';
    }

     //Performance
     filterPerformance(name: string) {
        name = _.escapeRegExp(name);
        return this.performanceList$.filter(item => (new RegExp(name, 'gi').test(item.performance_name)));
    }
    displayPerformanceFn(performanceID: number) {
        if (performanceID && this.performanceList$.length > 0) {
            let performanceitem = _.find(this.performanceList$, { 'performance_id': performanceID });
            this.haModelDet['performance_name'] = performanceitem['performance_name'];
            return performanceitem['performance_name'];
        }
        return '';
    }

    //Power
    filterPower(name: string) {
        name = _.escapeRegExp(name);
        return this.powerList$.filter(item => (new RegExp(name, 'gi').test(item.power_name)));
    }
    displayPowerFn(powerID: number) {
        if (powerID && this.powerList$.length > 0) {
            let poweritem = _.find(this.powerList$, { 'power_id': powerID });
            this.haModelDet['power_name'] = poweritem['power_name'];
            return poweritem['power_name'];
        }
        return '';
    }

    //Battery
    filterBattery(name: string) {
        name = _.escapeRegExp(name);
        return this.batteryList$.filter(item => (new RegExp(name, 'gi').test(item.battery_name)));
    }
    displayBatteryFn(batteryID: number) {
        if (batteryID && this.batteryList$.length > 0) {
            let batteryitem = _.find(this.batteryList$, { 'battery_id': batteryID });
            this.haModelDet['battery_name'] = batteryitem['battery_name'];
            return batteryitem['battery_name'];
        }
        return '';
    }

    loadAllList() {
        let that = this;
        //to get series list
        this.commonService
            .getAllList()
            .then(function(res: any) {
                const seriesdata = res.data.filter(item => item.brand_id === that.haModelDet['brand_id']);
                that.seriesList$ = seriesdata;
                that.seriesCtrl.setValue(that.haModelDet['series_id']);

                const powerdata = res.powerdata.filter(item => item.brand_id === that.haModelDet['brand_id']);
                that.powerList$ = powerdata;
                that.powerCtrl.setValue(that.haModelDet['power_id']);

                const performancedata = res.performancedata.filter(item => item.brand_id === that.haModelDet['brand_id']);
                that.performanceList$ = performancedata;
                that.performanceCtrl.setValue(that.haModelDet['performance_id']);

                // const batterydata = res.batterydata.filter(item => item.brand_id === that.haModelDet['brand_id']);
                that.batteryList$ = res.batterydata;
                that.batteryCtrl.setValue(that.haModelDet['battery_id']);

            });  
    }

    onAddHaModelDet(): void{
        let that = this,
            modelID = this.haModelDet['model_id'],
               modelName = this.haModelDet['hamodel_name'];

            if (!_.isEmpty(_.toString(modelID))) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.haModelDelList, { 'model_id': modelID });

            if (preTestID) {
                swal('WARNING', "HA Model :" + modelName + " Already Exists, so you can't Add Again!!!");
                return;
            }            
                this.haModelDelList.push(Object.assign({},this.haModelDet));
                this.haModelDet = [];
        }
    }
    loadOctTypeList() {
        let that = this;
        this.octTypeService.getOctTypeList({ start: 0, limit: 1000, orderColumn: 'name', orderDir: 'asc' })
            .then(function (res: any) {
                that.octTypeList = (res.data || []).filter((o: any) => o.status === 'Active');
                if (that._traildata && that._traildata['oct_type_id']) {
                    let val = that._traildata['oct_type_id'];
                    that._traildata['oct_type_id'] = null;
                    setTimeout(() => { that._traildata['oct_type_id'] = val; }, 0);
                }
            });
    }

    filterOctInitiatedBy(name: string) {
        name = _.escapeRegExp(name);
        return this.octInitiatedByList.filter(emp => (new RegExp(name, 'gi').test(emp.empid)
            || new RegExp(name, 'gi').test(emp.empname)));
    }

    displayOctTypeFn(octId: any): string {
        if (octId && this.octTypeList && this.octTypeList.length > 0) {
            let fitem = _.find(this.octTypeList, { 'id': Number(octId) });
            if (fitem) return fitem['name'];
        }
        return '';
    }

    displayOctInitiatedByFn(empID: any): string {
        if (empID && this.octInitiatedByList.length > 0) {
            let fitem = _.find(this.octInitiatedByList, { 'empid': empID });
            if (fitem) {
                this._traildata['oct_initiated_by'] = empID;
                return fitem['empname'];
            }
        }
        return '';
    }

    onSaveTrial(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        if (_.isEmpty(this.traildata['trail'])) {
            toast['body'] = 'Please Select Trail ';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(this.traildata['route_testing']) && _.isEmpty(this.traildata['route_trail'])) {
            toast['body'] = 'Please Select Route to Testing ';
            this.toasterService.pop(toast);
            return;
        }
        if(this.traildata['trail'] == 'Yes'){
            if(this.haModelDelList.length == 0){
                toast['body'] = 'Please Select HA Model Details ';
                this.toasterService.pop(toast);
                return;
            }
        }
        let that = this,
            data = {
                client_id: this.traildata['client_id'],
                walkin_date: this.traildata['walkin_date'],
                page_from: this.traildata['page_from'],
                walkin_id: this.traildata['walkin_id'],
                status: this.traildata['status'],
                trail: this.traildata['trail'],
                potential_customer: this.traildata['potential_customer'],
                route_testing: this.traildata['route_testing'],
                trail_description: this.traildata['trail_description'],
                trial_feedback: this.traildata['trial_feedback'],
                haModelDet: JSON.stringify(this.haModelDelList),
                trail_attender_name: this.traildata['trail_attender_name'],
                trail_attender_another_name: this.traildata['trail_attender_another_name'],
                trail_total_hours: this.traildata['trail_total_hours'],
                machine_type: this.traildata['machine_type'],
                bilateral_willing_client: this.traildata['bilateral_willing_client'],
                oct_type_id: this.traildata['oct_type_id'] || '',
                oct_initiated_by: this.traildata['oct_initiated_by'] || '',
                is_edit: this.traildata['is_edit'] || 'No'
            };
        this.isLoading = true;
        this.testingTrailService
            .updateTestingTrial(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.bsModalRef.hide();
                    that.testingTrailLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/testingTrail/addTrail.component.ts